import {onClick} from '../abstract/helpers.js';

export class SearchPopup {
  constructor(name, options) {

    
    this.controller = new AbortController();
    this.signal = this.controller.signal;

    let search_selectror = document.querySelectorAll('.search-toggle');
    let search_selector_mobile = document.querySelectorAll('.search-toggle-mobile');
    if(search_selectror) {

      search_selectror.forEach(function(el) {

        onClick(el, function (e) {
          e.preventDefault();

          let search_selectror = document.querySelector('.search-toggle');
          let search_wrapper = document.querySelector('.search-navigation.fixed');
          search_wrapper.classList.toggle('visible');

          document.querySelector('.search-navigation.fixed .search-loading').classList.remove('visible');
          document.querySelector('.search-navigation.fixed .search-suggestion-wrapper').classList.remove('visible');

          setTimeout(function() {
            let searchInput = document.querySelector('.search-navigation.fixed .search-bar-wrapper input');
            searchInput.focus();
          }, 300);

        }.bind(this));
      });

          
      onClick(document.querySelector('.search-navigation.fixed #load-results'), function (e) {
        e.preventDefault();

        document.querySelector('.search-navigation.fixed .search-loading').classList.add('visible');
        document.querySelector('.search-navigation.fixed .search-suggestion-wrapper').classList.remove('visible');

        let url = document.querySelector('.search-navigation.fixed .search-bar-wrapper input').getAttribute('data-url');
        let value = document.querySelector('.search-navigation.fixed .search-bar-wrapper input').value;

        let wordlist = value.match(/\b(\w+)\b/g);
        let sendlist = [];
        let search = '';

        var Typo = require("typo-js");
        var dictionary = new Typo("en_ZA", false, false, { dictionaryPath: myScriptData.siteUrl+"/wp-content/themes/SantheTheme v1/dictionaries" });

        if(wordlist) {
          wordlist.forEach(function(word) {

            var is_spelled_correctly = dictionary.check(word);

            if(is_spelled_correctly) {
              sendlist.push(word);
              search += word + ' ';
            } else {
              var array_of_suggestions = dictionary.suggest(word);
              sendlist.push(word);
              search += word + ' ';
              if(array_of_suggestions.length) {
                sendlist.push(array_of_suggestions[0]);
                search += array_of_suggestions[0] + ' ';
              }
            }

          }.bind(dictionary));
        }
        

        const  data = new FormData();
        data.append( 'action', 'get_ajax_posts' );
        data.append( 'terms', search );

        fetch(url, 
          {
            method: 'POST',
            signal: this.signal,
            credentials: 'same-origin',
            body: data
          }
          )
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          console.log(html);
          document.querySelector('.search-navigation.fixed .search-loading').classList.remove('visible');
          document.querySelector('.search-navigation.fixed .search-suggestion-wrapper').classList.add('visible');
          document.querySelector('.search-navigation.fixed .search-suggestion-wrapper').innerHTML = html;

          

        }.bind(this)).catch(function (err) {
          // There was an error
          document.querySelector('.default-content-area .card-wrapper').classList.remove("loading");
          console.warn('Something went wrong.', err);
        });


      }.bind(this));
    }

    if(search_selector_mobile) {

      search_selector_mobile.forEach(function(el) {

        onClick(el, function (e) {
          e.preventDefault();

          let search_selectror = document.querySelector('.search-toggle-mobile');
          let search_wrapper = document.querySelector('.search-mobile');
          search_wrapper.classList.toggle('visible');
          
          document.querySelector('.search-navigation.inline .search-loading').classList.remove('visible');
          document.querySelector('.search-navigation.inline .search-suggestion-wrapper').classList.remove('visible');

          setTimeout(function() {
            let searchInput = document.querySelector('.search-navigation.inline .search-bar-wrapper input');
            searchInput.focus();
          }, 300);

        }.bind(this));
      });

          
      onClick(document.querySelector('.search-navigation.inline #load-results'), function (e) {
        e.preventDefault();

        document.querySelector('.search-navigation.inline .search-loading').classList.add('visible');
        document.querySelector('.search-navigation.inline .search-suggestion-wrapper').classList.remove('visible');

        let url = document.querySelector('.search-navigation.inline .search-bar-wrapper input').getAttribute('data-url');
        let value = document.querySelector('.search-navigation.inline .search-bar-wrapper input').value;

        let wordlist = value.match(/\b(\w+)\b/g);
        let sendlist = [];
        let search = '';

        var Typo = require("typo-js");
        var dictionary = new Typo("en_ZA", false, false, { dictionaryPath: myScriptData.siteUrl+"/wp-content/themes/SantheTheme v1/dictionaries" });

        if(wordlist) {
          wordlist.forEach(function(word) {

            var is_spelled_correctly = dictionary.check(word);

            if(is_spelled_correctly) {
              sendlist.push(word);
              search += word + ' ';
            } else {
              var array_of_suggestions = dictionary.suggest(word);
              sendlist.push(word);
              search += word + ' ';
              if(array_of_suggestions.length) {
                sendlist.push(array_of_suggestions[0]);
                search += array_of_suggestions[0] + ' ';
              }
            }

          }.bind(dictionary));
        }
        

        const  data = new FormData();
        data.append( 'action', 'get_ajax_posts' );
        data.append( 'terms', search );

        fetch(url, 
          {
            method: 'POST',
            signal: this.signal,
            credentials: 'same-origin',
            body: data
          }
          )
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          console.log(html);
          document.querySelector('.search-navigation.inline .search-loading').classList.remove('visible');
          document.querySelector('.search-navigation.inline .search-suggestion-wrapper').classList.add('visible');
          document.querySelector('.search-navigation.inline .search-suggestion-wrapper').innerHTML = html;

          

        }.bind(this)).catch(function (err) {
          // There was an error
          document.querySelector('.default-content-area .card-wrapper').classList.remove("loading");
          console.warn('Something went wrong.', err);
        });


      }.bind(this));
    }  


    /*document.querySelector('.search-navigation.fixed .search-bar-wrapper input').addEventListener('change', function() {
        console.log('You selected: ', this.value);
      });*/





  }
}
